export default __webpack_public_path__ + "static/portfolio-77e19b1a049aad07ba83510e0614fba9.jpg";